import axios from 'axios';

const apiClient = axios.create({
  baseURL: `${process.env.VUE_APP_BASE_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

function getCookie(name) {
  const cookieString = document.cookie;
  const cookies = cookieString.split('; ').reduce((acc, cookie) => {
    const [key, value] = cookie.split('=');
    acc[key] = value;
    return acc;
  }, {});

  return cookies[name];
}

apiClient.interceptors.request.use(
  (config) => {
    const token = getCookie('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default apiClient;